import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Price from 'components/misc/Price'
import { useIntl } from '@trileuco/triskel-react-ui/components/i18n'
import _ from 'lodash'

export const AvailableTimeLabel = ({
  pickedPriceType,
  schedule,
  bookable,
  capacity
}) => {
  const { msg } = useIntl({
    scope: 'balaena.toBookPicker',
    ignoreGlobalScope: true
  })
  const showPrices = useMemo(() => {
    if (!pickedPriceType) {
      return false
    }
    let differentPrices = [pickedPriceType.price.amount]
    differentPrices.push(
      ...pickedPriceType.guestTypes.map((gt) => {
        return gt.price
      })
    )
    differentPrices = _.uniq(_.compact(differentPrices))
    return differentPrices.length === 1
  }, [pickedPriceType])
  return (
    <div className="AvailableTimes">
      {schedule && showPrices && (
        <span className="AvailableTimes_price">
          {msg(
            { id: 'pricePerGuest' },
            {
              price: (
                <span>
                  <Price
                    amount={
                      bookable.priceTypes.length > 1
                        ? pickedPriceType.price.amount
                        : schedule.priceAmount
                    }
                    currency={bookable.price.currency}
                  />
                </span>
              ),
              guest:
                bookable.priceTypes.length > 1
                  ? pickedPriceType.price.labels.singular
                  : bookable.price.labels.singular
            }
          )}
        </span>
      )}
      <span className="AvailableTimes_availability">
        {msg(
          { id: 'availability' },
          {
            remainingCapacity: capacity.remaining,
            totalCapacity: capacity.total
          }
        )}
      </span>
    </div>
  )
}
AvailableTimeLabel.propTypes = {
  bookable: PropTypes.shape(),
  pickedPriceType: PropTypes.shape(),
  schedule: PropTypes.shape(),
  capacity: PropTypes.shape()
}

AvailableTimeLabel.displayName = 'AvailableTimeLabel'
